import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { TextZoom } from "@capacitor/text-zoom";
import { Capacitor } from "@capacitor/core"; 

/* ===== GLOBAL GPS TRACKER (NAUJAS VARIKLIS) ===== */
/* Pastaba: Jei failą įsidėjai ne į "components" aplanką, pataisyk šį kelią */
import GlobalWorkerTracker from "./components/GlobalWorkerTracker"; 

/* ===== PUBLIC ===== */
import LandingPage from "./pages/LandingPage";
import AGBPage from "./pages/AGBPage";
import DatenschutzPage from "./pages/DatenschutzPage";

/* ===== LOGIN ===== */
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminLoginPage from "./pages/AdminLoginPage";

/* ===== ADMIN ===== */
import AdminDashboard from "./pages/AdminDashboard";
import AdminWorkers from "./pages/AdminWorkers";
import AdminWorkerArchive from "./pages/AdminWorkerArchive";
import AdminWeeklyPlan from "./pages/AdminWeeklyPlan";
import AdminProjects from "./pages/AdminProjects";
import AdminProjectFolder from "./pages/AdminProjectFolder";
import AdminProjectWeek from "./pages/AdminProjectWeek";
import AdminDocuments from "./pages/AdminDocuments";
import AdminDocumentsStatus from "./pages/AdminDocumentsStatus";
import AdminCompanyDocuments from "./pages/AdminCompanyDocuments";
import AdminCompanyDocumentView from "./pages/AdminCompanyDocumentView";
import AdminWorkHours from "./pages/AdminWorkHours";
import AdminWorkerWorkHours from "./pages/AdminWorkerWorkHours";
import AdminMaps from "./pages/AdminMaps";
import AdminSettings from "./pages/AdminSettings";
import AdminActs from "./pages/AdminActs";
import AdminWeeklyExport from "./pages/AdminWeeklyExport";
import BeweissicherungPage from "./pages/BeweissicherungPage";

/* ===== WORKER ===== */
import WorkerGatePage from "./pages/worker/WorkerGatePage";
import WorkerLoginPage from "./pages/worker/WorkerLoginPage";
import WorkerHomePage from "./pages/worker/WorkerHomePage";
import WorkerStartWork from "./pages/WorkerStartWork";
import WorkerWeekly from "./pages/WorkerWeekly";
import WorkerMyHours from "./pages/WorkerMyhours";
import WorkerDocuments from "./pages/WorkerDocuments";
import WorkerProfile from "./pages/worker/WorkerProfile";
import WorkerBeweissicherung from "./pages/worker/WorkerBeweissicherung";

// Saugus patikrinimas, ar tai telefonas, ar naršyklė
const isNative = Capacitor.isNativePlatform();

const App = () => {
  
  // --- ŠRIFTO DYDŽIO FIKSAVIMAS ---
  useEffect(() => {
    const lockTextZoom = async () => {
      if (isNative) { 
        try {
          await TextZoom.set({ value: 1 });
        } catch (error) {
          console.log("TextZoom not available", error);
        }
      }
    };
    
    lockTextZoom();
  }, []);
  // -----------------------------------------------

  return (
    <Router>
      
      {/* --- ČIA YRA TAVO NAUJAS NEMATOMAS DARBUOTOJAS --- */}
      {/* Jis veiks fone visada, nesvarbu kuriame puslapyje esi */}
      <GlobalWorkerTracker />
      {/* ------------------------------------------------- */}

      <Routes>

        {/* ROOT: Jei telefonas -> Worker, jei Webas -> LandingPage */}
        <Route path="/" element={isNative ? <Navigate to="/worker" replace /> : <LandingPage />} />

        {/* PUBLIC */}
        <Route path="/agb" element={<AGBPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* ADMIN */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/workers" element={<AdminWorkers />} />
        <Route path="/admin/workers/archive" element={<AdminWorkerArchive />} />
        <Route path="/admin/weeklyplan" element={<AdminWeeklyPlan />} />
        <Route path="/admin/projects" element={<AdminProjects />} />
        <Route path="/admin/projects/:projectId" element={<AdminProjectFolder />} />
        <Route path="/admin/projects/:projectId/:kw/:version" element={<AdminProjectWeek />} />
        <Route path="/admin/weekly-export" element={<AdminWeeklyExport />} />
        <Route path="/admin/workhours" element={<AdminWorkHours />} />
        <Route path="/admin/workhours/:workerId" element={<AdminWorkerWorkHours />} />
        <Route path="/admin/maps" element={<AdminMaps />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/beweissicherung" element={<BeweissicherungPage />} />
        <Route path="/admin/documents" element={<AdminDocuments />} />
        <Route path="/admin/documents/status/:status" element={<AdminDocumentsStatus />} />
        <Route path="/admin/documents/company" element={<AdminCompanyDocuments />} />
        <Route path="/admin/documents/company/view/:docId" element={<AdminCompanyDocumentView />} />
        <Route path="/admin/acts" element={<AdminActs />} />

        {/* WORKER */}
        <Route path="/worker" element={<WorkerGatePage />} />
        <Route path="/worker/login" element={<WorkerLoginPage />} />
        <Route path="/worker/home" element={<WorkerHomePage />} />
        <Route path="/worker/start-work" element={<WorkerStartWork />} />
        <Route path="/worker/weekly" element={<WorkerWeekly />} />
        <Route path="/worker/my-hours" element={<WorkerMyHours />} />
        <Route path="/worker/documents" element={<WorkerDocuments />} />
        <Route path="/worker/profile" element={<WorkerProfile />} />
        <Route path="/worker/reports" element={<WorkerBeweissicherung />} />

      </Routes>

    </Router>
  );
};

export default App;